import { Loader2 } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";

import { accountSettingsFieldRowClassName } from "./SettingCard";

type DisplayPreferenceUpdateRowProps = {
  children: React.ReactNode;
  onUpdate: () => void;
  disabled?: boolean;
  updating?: boolean;
  updateLabel?: string;
};

export function DisplayPreferenceUpdateRow({
  children,
  onUpdate,
  disabled = false,
  updating = false,
  updateLabel = "Update",
}: DisplayPreferenceUpdateRowProps): React.ReactElement {
  return (
    <div className={accountSettingsFieldRowClassName}>
      <div className="min-w-0 flex-1">{children}</div>
      <Button
        type="button"
        variant="gradient"
        size="sm"
        data-font="primary"
        className="shrink-0"
        disabled={disabled || updating}
        aria-busy={updating || undefined}
        onClick={onUpdate}
      >
        {updating ? (
          <Loader2 data-icon="inline-start" className="size-3.5 animate-spin" aria-hidden />
        ) : null}
        {updateLabel}
      </Button>
    </div>
  );
}
